import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Divider } from '@lightspeed/flame/Divider';
import { getValidDatesInRange } from './utils';
import { START_DATE } from '.';

class DateRangePickerPresets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      presetDates: this.initPresets(),
    };
  }

  componentDidUpdate(prevProps) {
    const { startDate, endDate } = this.props;

    if (
      !startDate.isSame(prevProps.startDate, 'day') ||
      !endDate.isSame(prevProps.endDate, 'day')
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        presetDates: this.selectPreset({ startDate, endDate }),
      });
    }
  }

  initPresets() {
    const { presetDates, startDate, endDate, availableStartDate, availableEndDate } = this.props;

    const presetIndex = presetDates.findIndex(
      preset => preset.startDate.isSame(startDate, 'day') && preset.endDate.isSame(endDate, 'day')
    );

    return presetDates.map((preset, index) => {
      const { validStartDate, validEndDate } = getValidDatesInRange({
        startDate: preset.startDate,
        endDate: preset.endDate,
        rangeStartDate: availableStartDate,
        rangeEndDate: availableEndDate,
      });

      return {
        ...preset,
        startDate: validStartDate,
        endDate: validEndDate,
        selected: presetIndex === index,
      };
    });
  }

  selectPreset({ selectedPresetIndex, startDate, endDate }) {
    const { presetDates } = this.state;
    const { presetDates: originalPresetDates } = this.props;
    let presetIndex = selectedPresetIndex;

    if (!selectedPresetIndex) {
      presetIndex = originalPresetDates.findIndex(
        originalPreset =>
          originalPreset.startDate.isSame(startDate, 'day') &&
          originalPreset.endDate.isSame(endDate, 'day')
      );
    }

    return presetDates.map((preset, index) => ({
      ...preset,
      selected: presetIndex === index,
    }));
  }

  handlePresetClick({ selectedPreset, selectedPresetIndex }) {
    const { onDatesChange } = this.props;

    if (!selectedPreset.selected) {
      onDatesChange({
        startDate: selectedPreset.startDate,
        endDate: selectedPreset.endDate,
        forceRender: true,
        selectedPreset: selectedPreset.label,
        focusedInput: START_DATE,
      });

      this.setState({
        presetDates: this.selectPreset({
          selectedPresetIndex,
          startDate: selectedPreset.startDate,
          endDate: selectedPreset.endDate,
        }),
      });
    }
  }

  render() {
    const { presetDates } = this.state;
    return (
      <div className="cr-date-picker__preset-dates cr-ph-2 cr-pv-1">
        {presetDates.map((preset, index) => {
          const presetButtonCls = cn('cr-date-picker__preset-dates-button', 'cr-text--bold', {
            'cr-date-picker__preset-dates-button--active': preset.selected,
          });

          return [
            // eslint-disable-next-line
            <div
              className={presetButtonCls}
              onClick={() =>
                this.handlePresetClick({ selectedPreset: preset, selectedPresetIndex: index })
              }
              key={preset.label}
              role="button"
            >
              {preset.label}
            </div>,
            preset.divider ? <Divider key={`${preset.label} divider`} /> : null,
          ];
        })}
      </div>
    );
  }
}

DateRangePickerPresets.propTypes = {
  presetDates: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      divider: PropTypes.bool,
      startDate: PropTypes.shape({
        _isAMomentObject: PropTypes.bool,
      }),
      endDate: PropTypes.shape({
        _isAMomentObject: PropTypes.bool,
      }),
      selected: PropTypes.bool,
    })
  ).isRequired,
  startDate: PropTypes.shape({
    _isAMomentObject: PropTypes.bool,
  }).isRequired,
  endDate: PropTypes.shape({
    _isAMomentObject: PropTypes.bool,
  }).isRequired,
  availableStartDate: PropTypes.shape({
    _isAMomentObject: PropTypes.bool,
  }).isRequired,
  availableEndDate: PropTypes.shape({
    _isAMomentObject: PropTypes.bool,
  }).isRequired,
  onDatesChange: PropTypes.func,
};

export default DateRangePickerPresets;
